import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { Tooltip } from '@/components/Tooltip'

// Same pattern as client-overrides/components/MaskedApiKeyField.tsx's own
// CopyButton (that one is private to PRD 06's file, not shared) - duplicated
// locally here rather than extracted, to keep this PRD's diff scoped to its
// own files.
export function CopyButton({ value }: { value: string }) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // Clipboard access can be denied (permissions, insecure context) -
      // nothing meaningful to recover into here, the operator can still
      // select-and-copy the text manually.
    }
  }

  return (
    <Tooltip text="Copy to clipboard">
      <button
        type="button"
        aria-label="Copy config bucket name"
        onClick={handleCopy}
        className="shrink-0 text-text-secondary hover:text-text-primary"
      >
        {copied ? (
          <Check size={16} strokeWidth={1.5} className="text-success" />
        ) : (
          <Copy size={16} strokeWidth={1.5} />
        )}
      </button>
    </Tooltip>
  )
}
